import formatters from "./formatters";

export const DEFAULT_DATE_FORMAT_TIMEZONE = "YYYY/MM/DD HH:mm zz";
export const DEFAULT_DATE_TIMEZONE = "America/Chicago";

export const AUDIT_LOG_COLUMNS = {
  item: {
    clickable: false,
    label: "Alerting Item",
    isVisible: true,
    resizable: true,
    width: 230,
    filter: "text",
  },
  request: {
    clickable: false,
    label: "Value",
    isVisible: true,
    resizable: true,
    sort: "date",
    width: 230,
    disabled: true,
  },
  performed_by: {
    clickable: false,
    label: "Performed By",
    isVisible: true,
    resizable: true,
    width: 230,
    filter: "text",
  },
  performed_at: {
    clickable: false,
    label: "Performed At",
    isVisible: true,
    resizable: true,
    width: 230,
    sort: "date",
    formatter: formatters.createdDate,
    // disabling the date filter as it needs a custom filter
    disabled: true,
  },
};
